/** Propuesta Total Tools × En Producción con MEM — Plan de Liderazgo Operativo ($380/mes). */

export const TOTAL_PROPOSAL = {
  eyebrow: 'Propuesta de visibilidad',
  title: 'Total Tools × En Producción con MEM',
  concept: 'Herramientas eléctricas e inalámbricas: autoridad en programa, rotativa y digital',
  brandSiteUrl: 'https://totaltoolsoficial.com.ve/',
  brandSiteLabel: 'totaltoolsoficial.com.ve',
  sectionOneTitle: 'El enfoque editorial: equipar a quien produce',
  intro:
    'Total Tools de Venezuela es la tienda oficial de herramientas eléctricas e inalámbricas, hogar y jardinería y accesorios — con despacho en el país, servicio técnico, garantía y compra en línea. En el programa y en TNO Network comunicamos:',
  editorialAxes: [
    {
      title: 'Portafolio que vende',
      body:
        'Taladros, lijadoras, soldadoras, generadores, línea 20V/42V y más: mensajes alineados a oportunidades y «La Herramienta de la Semana» en rotativa.',
    },
    {
      title: 'Cercanía con Mem',
      body:
        'María Eugenia Moreno muestra uso real, tips de taller o proyecto y enlaza con la tienda online cuando conviene cerrar la consulta o la compra.',
    },
    {
      title: 'Confianza de marca',
      body:
        'Refuerzo de garantía, soporte técnico, métodos de pago y logística (despacho en el país) como respaldo detrás del precio y la promoción.',
    },
  ],
  planExplainSection: {
    overline: 'Estructura de la alianza',
    title: 'Qué incluye cada partida del plan',
    subtitle: '$120 + $100 + $120 + $40 = $380 USD/mes',
    body:
      'Antes del resumen en tabla: streaming 24/7, segmento «Produciendo con Total Tools» con María Eugenia Moreno, artículos en TNO Digest y banners en el portal TNO (economía y producción).',
  },
  planExplainCards: [
    {
      service: 'Streaming',
      priceUsd: 120,
      icon: 'liveTv',
      details: [
        '12 impactos diarios (360 al mes) en la señal 24/7 de TNO Network.',
        'Spots con «La Herramienta de la Semana»: referencia a categorías y ofertas del catálogo Total Tools.',
      ],
      benefit:
        'Recordación constante de Total Tools con un gancho editorial claro hacia la tienda y el catálogo digital.',
    },
    {
      service: 'Segmento «Produciendo con Total Tools»',
      priceUsd: 100,
      icon: 'recordVoiceOver',
      details: [
        'Espacio semanal dentro de En Producción con MEM.',
        'Mem presenta una herramienta en contexto (obra, taller, hogar o emprendimiento) o un tip de uso y mantenimiento.',
      ],
      benefit:
        'El programa como vitrina de producto real: más allá del spot, se explica para quién sirve y por qué conviene.',
    },
    {
      service: 'Dominio SEO (TNO Digest)',
      priceUsd: 120,
      icon: 'menuBook',
      details: [
        '2 artículos mensuales (quincenales) en TNO Digest.',
        'Temas guía: «5 herramientas que no pueden faltar en tu taller», inalámbricas para el emprendedor o guía de compra inteligente.',
      ],
      benefit:
        'Captura búsquedas de herramientas, taller y equipamiento; enlaza autoridad editorial con totaltoolsoficial.com.ve.',
    },
    {
      service: 'Autoridad Digital',
      priceUsd: 40,
      icon: 'hub',
      details: [
        'Banners en el portal web de TNO vinculados a economía y producción, con ruta hacia la propuesta comercial / tienda.',
      ],
      benefit:
        'Refuerzo visual donde la audiencia profundiza después del programa y del Digest.',
    },
  ],
  planTableHeading: 'Resumen de inversión',
  planTitle: 'Desglose de inversión mensual (Plan de Liderazgo Operativo)',
  planRows: [
    {
      service: 'Streaming',
      detail:
        '12 impactos diarios (360 al mes) en la señal 24/7. Spots enfocados en «La Herramienta de la Semana» (catálogo y promociones Total Tools).',
      amount: '$120',
    },
    {
      service: 'Segmento: «Produciendo con Total Tools»',
      detail:
        'Espacio semanal en el programa: herramienta en uso o tip de mantenimiento / proyecto con productos Total Tools.',
      amount: '$100',
    },
    {
      service: 'Dominio SEO (TNO Digest)',
      detail:
        '2 artículos mensuales (quincenales). Temas: equipamiento de taller, herramientas inalámbricas o guía de compra hacia la tienda oficial.',
      amount: '$120',
    },
    {
      service: 'Autoridad Digital',
      detail:
        'Banners en el portal web de TNO vinculados a la sección de economía y producción.',
      amount: '$40',
    },
  ],
  planTotalLabel: 'Plan de Liderazgo Operativo',
  planTotalAmount: '$380',
  materialsTitle: 'Material para el programa y rotativa',
  radioScriptTitle: 'Para la rotativa (micro «La Herramienta de la Semana»)',
  radioScript:
    '¿Armas tu taller o tu próximo proyecto? Esta semana la herramienta que no puede faltar lleva el sello Total Tools: eléctricas, inalámbricas y accesorios con respaldo y garantía. Entra a totaltoolsoficial.com.ve y arma tu pedido. Total Tools, aliado de quien está produciendo hoy — En Producción con MEM, por TNO Network.',
  programTitle: 'Para el programa',
  programBullets: [
    '«Produciendo con Total Tools»: Mem integra producto, caso de uso y beneficio (obra, emprendimiento o mantenimiento en casa) con tono cercano.',
    'Coherencia con la rotativa: el segmento profundiza la «Herramienta de la Semana» y puede invitar a consultar ofertas o catálogo en la tienda oficial.',
  ],
  whatsappPhone: '04141355751',
  whatsappLabel: 'WhatsApp 0414-1355751',
  ctaBody:
    'Referencia: plan orientativo $380 USD/mes (streaming, segmento, Digest, banners). Escríbenos por WhatsApp; referencia esta propuesta Total Tools y coordinamos el siguiente paso.',
  whyTitle: 'Por qué este plan suma para Total Tools',
  whyPoints: [
    {
      title: 'Frecuencia + profundidad',
      body:
        '360 impactos al mes sostienen la marca; el segmento semanal explica la herramienta y acerca a la tienda online.',
    },
    {
      title: 'SEO que acompaña la conversación',
      body:
        'TNO Digest captura búsquedas de herramientas, taller y equipamiento, alineadas al discurso del programa y al e-commerce oficial.',
    },
    {
      title: 'Cierre en el portal TNO',
      body:
        'Los banners en economía/producción refuerzan autoridad digital junto al streaming y al contenido editorial.',
    },
  ],
};
